import { Box } from '@bridebook/ui';
import componentStyles from './carousel-counter.style';

interface CounterProps {
  total: number;
  currentIndex: number;
}

export const CarouselCounter = ({ total, currentIndex }: CounterProps) => {
  const styles = componentStyles();
  return <Box style={styles.wrapper}>{`${currentIndex} / ${total}`}</Box>;
};
